"use client";
import r, { useState as h, useEffect as f } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import A from "./index.es21.js";
import "./index.es22.js";
import g from "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import { generatePeerChoices as k, createChoicesGenerator as F } from "./index.es4.js";
const ae = ({
  geoTypes: y,
  regionsData: n,
  primaryRegion: t,
  comparisonRegions: a,
  onSelect: i
}) => {
  const [s, v] = h(
    k(t, n)
  ), [b, G] = h(
    a.filter((e) => s.find((l) => l.value === e.regionCode)).map((e) => e.regionCode)
  );
  f(() => {
    v(k(t, n));
  }, [t, n]), f(() => {
    G(
      a.filter((e) => s.find((l) => l.value === e.regionCode)).map((e) => e.regionCode)
    );
  }, [a, t]);
  const T = [t, ...a], E = F(
    y,
    n,
    T
  ), P = (e) => {
    const l = n.byCode[e.value];
    l && i([...a, l]);
  }, M = {
    Country: "Norge",
    County: "fylke",
    Region: "landsdel",
    Municipality: "kommune",
    CityPart: "bydel",
    CitySubPart: "delbydel",
    Cooperation: "samarbeid",
    Grouping: "gruppering"
  }, p = {
    Country: "lander",
    County: "fylker",
    Region: "landsdeler",
    Municipality: "kommuner",
    CityPart: "bydeler",
    CitySubPart: "delbydeler",
    Cooperation: "kommuner",
    Grouping: "bydeler"
  }[t.type], $ = t.parent ? M[t?.parent?.type] : "", c = (e) => (l) => {
    const C = l.map((o) => n.byCode[o]), N = e.map((o) => o.value), u = a.filter(
      (o) => !N.includes(o.regionCode) || C.includes(o)
    );
    for (const o of C)
      u.includes(o) || u.push(o);
    i(u);
  }, m = (e) => `(${e.values.length}/${e.choices.length})`, d = (t.kostraGroup ? n.array.filter(
    (e) => e.kostraGroup === t.kostraGroup && e.regionCode !== t.regionCode
  ) : []).map((e) => ({
    value: e.regionCode,
    display: e.name
  })), V = t.kostraGroup ? a.filter((e) => e.kostraGroup === t.kostraGroup).map((e) => e.regionCode) : [], x = t.type === "County" ? "Multivalg av fylker" : `Multivalg av ${p} i samme ${$}`;
  return /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement(
    A,
    {
      name: "comparison-region-input",
      generateChoices: E,
      label: "Velg sted du vil sammenligne med",
      placeholder: "Begynn å skrive stedsnavn",
      onChange: P
    }
  ), s.length > 0 && /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
    g,
    {
      choices: s,
      values: b,
      btnText: m,
      label: x,
      onChange: c(s)
    }
  )), !!t.kostraGroup && /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
    g,
    {
      btnText: m,
      label: `Multivalg av ${p} i samme kostragruppe`,
      onChange: c(d),
      choices: d,
      values: V
    }
  )));
};
export {
  ae as default
};
//# sourceMappingURL=index.es53.js.map
